var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pda-stats-item"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"pda-stats-value"},[_vm._v(_vm._s(_vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }